import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableSortLabel } from "@mui/material";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Box } from "@mui/system";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const RawDataTable = ({ tableHeadings, rows }: Props) => {
  const headCells = Object.entries(tableHeadings);

  return (
    <>
      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer className="">
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headCells.map(([_, value], index) => (
                  <TableCell
                    key={index}
                    align="left"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    <TableSortLabel>
                      {value && typeof value === "string" ? value : ""}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <React.Fragment key={row.cron_id}>
                  <TableRow
                    sx={{
                      "& > *": {
                        borderBottom:
                          "1px solid rgba(224, 224, 224, 1) !important",
                      },
                    }}
                  >
                    {headCells.map(([key], cellIndex) => (
                      <TableCell key={cellIndex} align="left">
                        {key === "created_timestamp" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "player_id" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "commission_earned" ? (
                          <>
                            {row[key] != null && row[key] !== "" && (
                              <Box display="flex" alignItems="center">
                                <span style={{ color: "#1B5E20" }}>
                                  {" "}
                                  {row[key]}{" "}
                                </span>

                                {row.currency === "USD" ? (
                                  <AttachMoneyIcon
                                    sx={{
                                      color: "rgba(0, 0, 0, 0.56)",
                                      fontSize: "20px",
                                      ml: 1,
                                    }}
                                  />
                                ) : row.currency === "GBP" ? (
                                  <CurrencyPoundIcon
                                    sx={{
                                      color: "rgba(0, 0, 0, 0.56)",
                                      fontSize: "18px",
                                      ml: 1,
                                    }}
                                  />
                                ) : null}
                              </Box>
                            )}
                          </>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default RawDataTable;
